(()=>{
const form=document.querySelector('#NuvoraWithdrawalForm');
if(!form)return;
const storageKey='nuvora-withdrawal-pending';
const success=form.querySelector('[data-withdrawal-success]');
if(success){
 let record=null;
 try{record=JSON.parse(sessionStorage.getItem(storageKey)||'null');sessionStorage.removeItem(storageKey)}catch{}
 if(record&&Date.now()-record.timestamp<3600000){
  const copy='NUVORA STUDIO — COPIE DE DÉCLARATION DE RÉTRACTATION\n\n'+record.body+'\n\nTransmission confirmée par le formulaire Shopify.\nCette copie utilise l’horloge du navigateur et ne remplace pas l’accusé de réception du SAV.\nContact : contact@nuvora-store.fr';
  const url=URL.createObjectURL(new Blob([copy],{type:'text/plain;charset=utf-8'}));
  const download=form.querySelector('[data-withdrawal-download]');
  download.href=url;download.download='nuvora-declaration-retractation.txt';download.hidden=false;
  form.querySelector('[data-withdrawal-receipt-note]').hidden=false;
  window.addEventListener('pagehide',()=>URL.revokeObjectURL(url),{once:true});
 }
 return;
}
const fields=form.querySelector('[data-withdrawal-fields]');
const review=form.querySelector('[data-withdrawal-review]');
const summary=form.querySelector('[data-withdrawal-summary]');
const submit=form.querySelector('[data-withdrawal-submit]');
const body=form.querySelector('[data-withdrawal-body]');
const error=form.querySelector('[data-withdrawal-error]');
if(!fields||!review||!submit)return;
const inputs=[...fields.querySelectorAll('input,textarea')];
let reviewed=false;
submit.textContent='Vérifier ma demande';
const values=()=>inputs.map(input=>({label:form.querySelector('label[for="'+input.id+'"]').textContent,value:input.value.trim()||'Non renseignée'}));
const edit=()=>{reviewed=false;fields.hidden=false;review.hidden=true;submit.textContent='Vérifier ma demande';inputs[0].focus()};
form.querySelector('[data-withdrawal-edit]').addEventListener('click',edit);
fields.addEventListener('input',()=>{reviewed=false});
form.addEventListener('submit',event=>{
 if(!form.checkValidity()){event.preventDefault();fields.hidden=false;form.reportValidity();return}
 if(!reviewed){
  event.preventDefault();summary.replaceChildren();
  for(const item of values()){
   const term=document.createElement('dt');term.textContent=item.label;
   const description=document.createElement('dd');description.textContent=item.value;
   summary.append(term,description);
  }
  reviewed=true;fields.hidden=true;review.hidden=false;submit.textContent='Confirmer la rétractation';
  form.querySelector('#WithdrawalReviewTitle').focus();return;
 }
 const now=new Date();
 const message='Je vous notifie ma décision de me rétracter du contrat pour les appareils et quantités ci-dessous.\n\n'+values().map(item=>item.label+' : '+item.value).join('\n')+'\n\nDate et heure de soumission (horloge du navigateur) : '+now.toLocaleString('fr-FR',{timeZone:'Europe/Paris'})+' (Europe/Paris)\nHorodatage UTC : '+now.toISOString();
 body.value=message;
 try{sessionStorage.setItem(storageKey,JSON.stringify({body:message,timestamp:now.getTime()}))}catch{}
 error.hidden=true;
});
})();